var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import hyperscript from 'mithril/hyperscript';
import trust from 'mithril/render/trust';
var mithrilRender;
// Mithril's render relies on browser-specific globals, so we check the environment first
if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-undef
    mithrilRender = require('mithril/render');
}
else {
    mithrilRender = {
        render: function (el, vnodes) { }
    };
}
export function render(el, vnodes) {
    return mithrilRender.render(el, vnodes);
}
export function unsafelyCreateElementFromString(string) {
    return trust(string);
}
function hasLifecycleHooks(attributes) {
    return attributes.componentDidMount || attributes.componentDidUpdate || attributes.componentWillUnmount;
}
export function createElement(elementName, attributes) {
    var children = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        children[_i - 2] = arguments[_i];
    }
    if (attributes === null || attributes === undefined) {
        return hyperscript.apply(void 0, __spreadArrays([elementName, null], children));
    }
    var oncreate = function (vnode) {
        vnode.state.__removed = false;
        attributes.componentDidMount(vnode.dom, vnode.state);
    };
    var onupdate = function (vnode) { return attributes.componentDidUpdate(vnode.dom, vnode.state); };
    var onremove = function (vnode) {
        //https://github.com/MithrilJS/mithril.js/issues/1990
        if (!vnode.state.__removed) {
            attributes.componentWillUnmount(vnode.dom, vnode.state);
        }
        vnode.state.__removed = true;
    };
    var mithrilAttributes = Object.keys(attributes).reduce(function (mithrilAttributes, name) {
        if (name === 'componentDidMount') {
            mithrilAttributes.oncreate = oncreate;
        }
        else if (name === 'componentWillUnmount') {
            mithrilAttributes.onremove = onremove;
        }
        else if (name === 'componentDidUpdate') {
            mithrilAttributes.onupdate = onupdate;
        }
        else if (name === 'lifecycleKey' || name === 'key') {
            mithrilAttributes.key = [attributes.lifecycleKey, attributes.key].filter(function (key) { return key; }).join('-');
        }
        else {
            mithrilAttributes[name] = attributes[name];
        }
        return mithrilAttributes;
    }, {});
    // @see: https://github.com/MithrilJS/mithril.js/issues/1994
    if (hasLifecycleHooks(attributes) && !attributes.lifecycleKey) {
        throw Error("Element '" + elementName + "' is using lifecycle hooks, but does not have 'lifecycleKey' attribute.");
    }
    var vdom = hyperscript.apply(void 0, __spreadArrays([elementName, mithrilAttributes], children));
    // @see: https://github.com/MithrilJS/mithril.js/issues/1994
    return (attributes.lifecycleKey ? [vdom] : vdom);
}
//# sourceMappingURL=mithril.js.map